import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Download, Share, X, Plus } from "lucide-react";

// "Add to Home Screen / Install app" — uses the native install prompt on
// Android/Chrome; shows step-by-step instructions on iOS Safari.
export function InstallButton({ className }) {
  const [deferred, setDeferred] = useState(null);
  const [sheet, setSheet] = useState(false);

  const standalone =
    (typeof window !== "undefined" &&
      (window.matchMedia?.("(display-mode: standalone)")?.matches || window.navigator.standalone)) || false;
  const isIOS = /iphone|ipad|ipod/i.test((typeof navigator !== "undefined" && navigator.userAgent) || "");

  useEffect(() => {
    const handler = (e) => { e.preventDefault(); setDeferred(e); };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  if (standalone) return null;

  const onClick = async () => {
    if (deferred) {
      deferred.prompt();
      await deferred.userChoice;
      setDeferred(null);
      return;
    }
    setSheet(true);
  };

  return (
    <>
      <Button onClick={onClick} data-testid="install-app-btn" className={className}>
        <Download className="mr-1.5 h-4 w-4" /> Install App
      </Button>

      {sheet && (
        <div className="fixed inset-0 z-[70] flex items-end bg-black/50" onClick={() => setSheet(false)} data-testid="install-sheet">
          <div className="w-full rounded-t-2xl bg-card p-5" onClick={(e) => e.stopPropagation()} style={{ paddingBottom: "calc(env(safe-area-inset-bottom) + 1.25rem)" }}>
            <div className="flex items-center justify-between">
              <h3 className="font-heading text-lg font-bold">Install Send-Proof</h3>
              <button onClick={() => setSheet(false)}><X className="h-5 w-5 text-muted-foreground" /></button>
            </div>
            <p className="mt-1 text-sm text-muted-foreground">Get the full-screen app on your home screen — no app store needed.</p>
            <ol className="mt-4 space-y-3 text-sm text-foreground">
              <li className="flex items-center gap-2">
                <span className="flex h-6 w-6 items-center justify-center rounded-full bg-emerald-500/15 text-xs font-bold text-emerald-500">1</span>
                Tap the {isIOS ? <Share className="mx-1 inline h-4 w-4" /> : <span className="mx-1 font-bold">⋮</span>} {isIOS ? "Share" : "menu"} button in your browser.
              </li>
              <li className="flex items-center gap-2">
                <span className="flex h-6 w-6 items-center justify-center rounded-full bg-emerald-500/15 text-xs font-bold text-emerald-500">2</span>
                Choose <b className="mx-1 inline-flex items-center gap-1"><Plus className="h-3.5 w-3.5" /> Add to Home Screen</b>.
              </li>
              <li className="flex items-center gap-2">
                <span className="flex h-6 w-6 items-center justify-center rounded-full bg-emerald-500/15 text-xs font-bold text-emerald-500">3</span>
                Tap <b className="mx-1">Add</b> — it opens like a real app, full screen.
              </li>
            </ol>
          </div>
        </div>
      )}
    </>
  );
}
